import React, { useEffect, useState } from "react";

import { object, func, array, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TextField from "../../atoms/TextField";
import Button from "../../atoms/button";
import NotLoggedInView from "../../molecules/not-logged-in-view";
import PlanInfo from "./plan-info";
import CancelSubscription from "./cancel-subscription";

import { setMember, setUserPlans, setLoading, setLogoutState } from "../../helper/actions";
import { getUserMetaData, getPushNotificationStatus, getActivePlans } from "../../utils/utils";
import { updateUserInformation, getUser, logout } from "../../helper/api";
import { getMyPlans } from "../../helper/access-type";

import "./dashboard.m.css";

const DashboardPageView = ({
  member,
  setLoading,
  setMember,
  setLogoutState,
  myPlans,
  navigateToPage,
  isPlansLoaded,
  setUserPlans,
}) => {
  if (!member) {
    return <NotLoggedInView />;
  }

  if (!isPlansLoaded) {
    setLoading(true);
  } else {
    setLoading(false);
  }

  const [profile, setProfile] = useState(getUserMetaData(member));
  const activePlans = getActivePlans(myPlans);

  useEffect(() => {
    setProfile(getUserMetaData(member));
  }, [member]);

  const setData = (e) => {
    const obj = { ...profile };

    obj[e.target.name] = e.target.value;
    setProfile(obj);
  };

  const saveProfileClick = () => {
    setLoading(true);
    updateUserInformation(profile)
      .then(() => {
        getUser().then((response) => setMember(response.member));
      })
      .catch((ex) => console.log(ex))
      .finally(() => setLoading(false));
  };

  const sortItems = (a, b) => {
    if (
      (a.status === "active" && b.status !== "active") ||
      (a.status === "pending" && b.status !== "pending" && b.status !== "active")
    )
      return -1;
    else if (
      (a.status !== "active" && b.status === "active") ||
      (a.status !== "active" && a.status !== "pending" && b.status === "pending")
    )
      return 1;
    else return 0;
  };

  const updatePlans = () => {
    getMyPlans().then((plans) => {
      setUserPlans(plans);
    });
  };

  const logoutClick = () => {
    setLoading(true);

    logout()
      .then(() => {
        window.google.accounts.id.disableAutoSelect();
        setMember(null);
        setLogoutState();
        delete window.app.m_status;
        window.localStorage.removeItem("USER:GTM");
        window.dataLayer.push({
          event: "logout",
          userid: "",
          user_type: "Non Paid",
          connect_level: getPushNotificationStatus(),
          login: "No",
          m_status: "",
        });
      })
      .finally(() => {
        setLoading(false);
        window.location.href = "/";
      });
  };

  const getFieldsView = () => {
    return (
      <div styleName="fields-wrapper">
        <TextField placeholder="Occupation" name="occupation" value={profile.occupation} onChange={setData} />
        <TextField placeholder="Mobile Number" name="mobileNumber" value={profile.mobileNumber} onChange={setData} />
        <TextField placeholder="City" name="city" value={profile.city} onChange={setData} />
        <TextField placeholder="Pincode" name="pincode" value={profile.pincode} onChange={setData} />
      </div>
    );
  };

  return (
    <div styleName="wrapper" className="container">
      <div styleName="welcome-content">
        <div styleName="user-name">Welcome {member.name || member["first-name"] || ""},</div>
        <div styleName="content-description">You can review and manage your membership information here.</div>
        <a
          styleName="join-members-group"
          href="https://www.facebook.com/groups/2596502677070141/"
          target="_blank"
          rel="nofollow"
        >
          Join Our Exclusive Member’s Group
        </a>
      </div>
      {myPlans.length ? (
        <div styleName="membership-content">
          <div styleName="upgrade-wrapper">
            <div styleName="membership-info">MEMBERSHIP INFO</div>
            <div styleName="upgrade-plan">Upgrade</div>
          </div>
          {myPlans.sort(sortItems).map((plan) => (
            <PlanInfo plan={plan} key={plan.id} />
          ))}
        </div>
      ) : null}

      <div styleName="profile-details">
        <div styleName="more-details-title">Just a few more details</div>
        {getFieldsView()}
        <div styleName="actions-wrapper">
          <Button content="Save" buttonType="type2" onClick={saveProfileClick} />
          <Button content="Sign Out" buttonType="type1" onClick={logoutClick} />
        </div>
      </div>

      {activePlans.length !== 0 && (
        <div styleName="cancel-membership">
          <span styleName="cancel-membership-title">CANCEL MEMBERSHIP</span>
          <CancelSubscription myPlans={myPlans} member={member} setLoading={setLoading} updatePlans={updatePlans} />
        </div>
      )}

      <div styleName="queries-wrapper">
        For queries, email us at &nbsp;
        <a href="mailto:membership@thequint.com">membership@thequint.com</a>
      </div>
    </div>
  );
};

DashboardPageView.propTypes = {
  member: object,
  setLoading: func,
  setMember: func,
  navigateToPage: func,
  setUserPlans: func,
  setLogoutState: func,
  myPlans: array,
  isPlansLoaded: bool,
};

const mapStateToProps = (state) => ({
  member: state.member,
  myPlans: get(state, ["userReducer", "myPlans"], []),
  isPlansLoaded: get(state, ["userReducer", "isPlansLoaded"], false),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
  setMember: (member) => dispatch(setMember(member)),
  setLogoutState: () => dispatch(setLogoutState()),
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setUserPlans: (plans) => dispatch(setUserPlans(plans)),
});

const DashboardPage = connect(mapStateToProps, mapDispatchToProps)(DashboardPageView);

export { DashboardPage };
